import Routers from "./shared/routers/routers";
import MyProvider from "./shared/components/context/MyProvider";
import theme from "./shared/theme/theme";
import "./App.css";

import { ThemeProvider } from "@mui/material/styles";

function App() {
  console.log(process.env);
  return (
    <ThemeProvider theme={theme}>
      <MyProvider>
        <Routers />
      </MyProvider>
    </ThemeProvider>
  );
}

export default App;
